<template>
  <b-modal
    :title="file.categoria
      ? `Ver respuesta Expediente ${file.categoria}-${file.numero}`
      : `Ver respuesta Expediente ${file.numero}`"
    v-model="showModal"
    hide-footer
    centered
  >
    <div>
      <h5>
        Respuesta
      </h5>
      <vs-table
        :data="fileResponse"
      >
        <template slot="thead">
          <vs-th>
            Nombre usuario
          </vs-th>
          <vs-th>
            Archivo
          </vs-th>
          <vs-th>
            Ver
          </vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
            <vs-td>
              {{ data[indextr].usuarioNombre }}
            </vs-td>
            <vs-td :data="fileResponse[indextr].adjuntoId">
              {{data[indextr].adjuntoNombre}}
            </vs-td>
            <vs-td>
              <DownloadFile
                :mood="'compact'"
                :path="data[indextr].adjuntoUrl"
                :name="data[indextr].adjuntoNombre"
                class="pill-info-attach"
              />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </b-modal>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import DownloadFile from '@/febos/chile/dnt/components/DownloadFile';

export default {
  name: 'PopUpViewResponseAguasAndinas',
  mixins: [],
  components: {
    DownloadFile
  },
  data() {
    return {
      fileType: 'numInt',
      creatorGroup: '',
      additionalFile: {
        name: ''
      },
      userFileResponse: [],
      estado: false
    };
  },
  props: {
    file: {
      type: [Object],
      required: true,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters('Modals', ['modalName']),
    ...mapGetters('List', ['userGroupsState']),
    ...mapGetters('Usuario', ['currentUser']),
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('Dnts', ['detailsFile', 'participants', 'attachmentsFile']),
    showModal: {
      get() {
        return this.modalName === 'PopUpViewResponseAguasAndinas';
      },
      set() {
        this.closeModal();
      }
    },
    isArchivo() {
      if (this.additionalFile.name.length > 0) {
        return true;
      }
      return false;
    },
    fileResponse() {
      return (this.attachmentsFile || []).filter((adjunto) => adjunto.tipo === 'respuesta');
    }
  },
  methods: {
    ...mapActions('Dnts', [
      'answerCreateFile',
      'getFileDnt',
      'returnFileEdAguasAndinas'
    ]),
    ...mapActions('Modals', [
      'closeModal'
    ]),
    cancelAsign() {
      this.closeModal();
    }
  }
};
</script>
<style scoped>

.bg-alert {
  background: #671e85;
  border-radius: 5px;
  color: white;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 10px 15px;
  background: rgba(var(--vs-primary), 1) !important;
  color: white !important;
}

</style>
